import {Record} from 'immutable';

import FileRecord from 'web-app/react/components/file-upload/file-record';
import * as ImageUtil from 'web-app/util/image';

/**
 * Takes the output from the FileInput component and converts it to the file keys the REST api expects
 * @param rawFiles
 * @returns {{imageIds: Array, videoIds: Array, fileIds: Array}}
 */
export const getFileArrays = rawFiles => {
    const imageIds = [];
    const videoIds = [];
    const fileIds = [];
    if (rawFiles) {
        rawFiles.forEach(file => {
            if (file.type.match('image')) {
                imageIds.push(file.id);
            } else if (file.type.match('video')) {
                videoIds.push(file.id);
            } else {
                fileIds.push(file.id);
            }
        });
    }

    const images = imageIds.map(imageId => ({imageId}));
    const videos = videoIds.map(videoId => ({videoId}));
    const files = fileIds.map(fileId => ({fileId}));

    return {
        imageIds,
        videoIds,
        fileIds,
        images,
        videos,
        files,
    };
};

export const imageToFileRecord = image => {
    const imageUrl = ImageUtil.getImageUrl(image, 100, 100);
    const previewUrl = ImageUtil.getImageUrl(image, image.width, image.height);
    return new FileRecord({
        name: '',
        type: 'image',
        id: image.imageId || image.id,
        uploadProgress: null,
        height: image.height,
        width: image.width,
        item: {...image, mediaType: 'Image'},
        previewUrl,
        thumbnailUrl: imageUrl,
        videoDuration: null,
        url: image.url,
    });
};

export const fileToFileRecord = file => {
    return new FileRecord({
        name: file.filename || file.name,
        type: 'file',
        id: file.fileId || file.id,
        uploadProgress: null,
        videoDuration: null,
        url: file.url,
    });
};

export const audioToFileRecord = audio => {
    return new FileRecord({
        name: audio.filename,
        type: audio.contentType,
        id: audio.id,
        item: {temporaryFileUrl: audio.signedUrl, mediaType: 'Audio'},
        uploadProgress: null,
        url: audio.signedUrl,
    });
};

export const videoToFileRecord = video => {
    if (!video) {
        return null;
    }

    // 'video' can be a plain object or an immutablejs Record
    const videoObj = Record.isRecord(video) ? video.toJS() : video;

    return new FileRecord({
        name: '',
        type: 'video',
        item: {...videoObj, mediaType: 'Video'},
        id: video.videoId || video.id,
        uploadProgress: null,
        previewUrl: video.thumbnailUrl,
        thumbnailUrl: video.thumbnailUrl,
        videoDuration: video.duration,
    });
};
